import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { InformationMessage } from './information.types';

@Injectable({
  providedIn: 'root'
})
export class InformationService {
  _messagesInitialized = false;
  _infoMessages$: ReplaySubject<InformationMessage[]> = new ReplaySubject<
    InformationMessage[]
  >(1);
  constructor(private _httpClient: HttpClient) {}

  getInfoMessages(refresh?: boolean): Observable<InformationMessage[]> {
    if (refresh || !this._messagesInitialized) {
      this._messagesInitialized = true;
      this._httpClient
        .get<InformationMessage[]>(
          'https://apiprivat.ishavskraft.no/v2/varsling/enkel'
        )
        .subscribe({
          next: (messages) => {
            this._infoMessages$.next(messages);
          },
          error: (error) => {
            this._infoMessages$.error(error);
          }
        });
    }
    return this._infoMessages$.asObservable();
  }
}
